
import { Vue, Component } from "vue-property-decorator";

@Component({ name: "icon-file-text" })
export default class IconFileText extends Vue {}
